import {useStore} from "vuex";
import {computed} from "vue";

export default function UseAddress() {
  const store = useStore()

  const getAddressVariants = query => {
    store.dispatch('house/getAddressVariants', query)
      .then(response => response)
  }

  const addressVariantClick = address => {
    return store.dispatch('house/addressVariantClick', address)
  }

  const inputAddress = computed({
    get: () => store.state.house.houseForm.house.address,
    set: newVal => store.dispatch('house/addressValueChange', newVal)
  })

  const findAddress = () => {
    return store.dispatch('house/getHouseInfo', store.state.house.address.sign)
  }

  return {
    variantsList: computed(() => store.getters["house/getVariantsList"]),
    inputAddress,
    getAddressVariants,
    addressVariantClick,
    findAddress,
    hasHouseInAddress: computed(() => store.state.house.address.hasHouseInAddress)
  }
}
